import React, { useState } from 'react';
import { Drawer, FloatButton } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import AuditTrail from './audittrail';

// Keeps the audit trail out of the page layout until the user asks for it.
const AuditTrailToggle: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <FloatButton
        icon={<HistoryOutlined />}
        tooltip="Audit trail"
        aria-label="Show audit trail"
        onClick={() => setOpen(true)}
      />
      <Drawer
        title="Audit Trail"
        open={open}
        onClose={() => setOpen(false)}
        width={420}
        destroyOnClose
        styles={{ body: { padding: 0 } }}
      >
        {open && <AuditTrail showTitle={false} />}
      </Drawer>
    </>
  );
};

export default AuditTrailToggle;
